
export enum OperationStatus {
  Pending = 2,
  InProgress = 3,
  Complete = 5,
  Canceled = 6,
  Failed = 7
}
